import { useContext, useState } from "react";
import { AppContext } from "../Context";

function Menu() {
  const { state } = useContext(AppContext);
  const { dispatch } = useContext(AppContext);
  const [showExtra, setShowExtra] = useState(false); // controls opacity
  const [isMounted, setIsMounted] = useState(false); // controls display
  const align = showExtra ? "flex-start" : "center";
  let padding = showExtra ? "20px" : "0px";

  if (state.orientation == "landscape") {
    padding = "0px";
  }

  const menuList = [
    { id: 'fabric', file: 'fabric.svg', label: 'Fabric' },
    { id: 'collar', file: 'CollarNormal.svg', label: 'Collar' },
    { id: 'cuff', file: 'cuff.svg', label: 'Cuff' },
    { id: 'monogram', file: 'monogram.svg', label: 'Monogram' },
    { id: 'plus', file: showExtra ? 'minus.svg' : 'plus.svg', label: 'Additional Options' }
  ];

  const menuExtraList = [
    { id: 'pocket', file: 'Pocket1.svg', label: 'Pocket' },
    { id: 'contrast', file: 'whiteCollarCuff.svg', label: 'Contrast Fabric' },
    { id: 'stitch', file: 'stitch.svg', label: 'Button Hole Stitch' },
    { id: 'tuxedo', file: 'studPleat.svg', label: 'Tuxedo' },
    { id: 'placket', file: 'placket.svg', label: 'Placket' },
  ];

  function onMenuClick(id) {
    dispatch({ type: "SET_MENU", payload: id });
  }

  function MenuButton({ id, image, label }) {
    return (
      <div
        id={id}
        data-btntype="menuButton"
        className="menuButton"
        onClick={() => {
          if (id === 'plus') {
            if (!isMounted) {
              setIsMounted(true);
              setTimeout(() => {
                setShowExtra(true);
              }, 10);
            } else {
              setShowExtra((prev) => !prev);
            }
          } else {
            onMenuClick(id);
          }
        }}
      >
        <div className="menuBtnBox">
          <img className="menuButtonIcon" src={image} alt={label} />
          <div className="menuLabel">{label}</div>
        </div>
      </div>
    );
  }

  const handleTransitionEnd = () => {
    if (!showExtra) setIsMounted(false);
  };

  return (
    <div className="menu" style={{ alignItems: align, paddingLeft: padding }}>
      <div className="menuContainer">
        {menuList.map((item) => (
          <MenuButton key={item.id} id={item.id} image={process.env.PUBLIC_URL + `/images/${item.file}`} label={item.label} />
        ))}

        {isMounted && (
          <div className={`extra ${showExtra ? 'showExtra' : ''}`} onTransitionEnd={handleTransitionEnd}          >
            {menuExtraList.map((item) => (
              <MenuButton key={item.id} id={item.id} image={process.env.PUBLIC_URL + `/images/${item.file}`} label={item.label} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Menu;
